module.exports = __webpack_public_path__ + "img/iconislamic.6c2b20f6.png";